import Breadcrumb from "components/Common/Breadcrumb"
import Loader from "components/Loader/loader"
import React, { useEffect, useState } from "react"
import {
  Card,
  CardBody,
  Col,
  Container,
  Row,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  Table,
} from "reactstrap"
import classnames from "classnames"
import { fetchData } from "utils/Common_api_functions"
import moment from "moment"

const ActivityOverview = () => {
  const [loading, setLoading] = useState(false)
  const [activeTab, setActiveTab] = useState("day")
  const [data, setData] = useState([])
  const [inactiveUsers, setInactiveUsers] = useState({})

  const toggleTab = tab => {
    if (activeTab !== tab) setActiveTab(tab)
  }

  useEffect(() => {
    getData()
  }, [])

  async function getData() {
    const APIdata = await fetchData(setLoading, "logs/email/logs")
    if (APIdata?.emailLogs) {
      setData(APIdata?.emailLogs?.reverse())
    }

    const APIdata1 = await fetchData(setLoading, "user/all/inactive")
    if (APIdata1) {
      setInactiveUsers(APIdata1)
    }
  }

  return (
    <div className="page-content">
      {loading && <Loader />}
      <Container fluid>
        <Breadcrumb title="Users" breadcrumbItem="Activity Overview" />

        <Row>
          <Col lg="12">
            <Card>
              <CardBody>
                <div className="d-flex justify-content-between align-items-center mb-3 border-bottom border-dark pb-2">
                  <h4 className="text-black fw-bold ps-1 mb-0">
                    Activity Overview
                  </h4>

                  {/* Tabs Navigation */}
                  <Nav tabs className="justify-content-end fs-5">
                    <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === "day" })}
                        onClick={() => toggleTab("day")}
                        style={{ cursor: "pointer" }}
                      >
                        Day
                      </NavLink>
                    </NavItem>

                    <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === "week" })}
                        onClick={() => toggleTab("week")}
                        style={{ cursor: "pointer" }}
                      >
                        Week
                      </NavLink>
                    </NavItem>

                    <NavItem>
                      <NavLink
                        className={classnames({
                          active: activeTab === "month",
                        })}
                        onClick={() => toggleTab("month")}
                        style={{ cursor: "pointer" }}
                      >
                        Month
                      </NavLink>
                    </NavItem>

                    <NavItem>
                      <NavLink
                        className={classnames({
                          active: activeTab === "activeInactive",
                        })}
                        onClick={() => toggleTab("activeInactive")}
                        style={{ cursor: "pointer" }}
                      >
                        Active / Inactive Users
                      </NavLink>
                    </NavItem>
                  </Nav>
                </div>

                {/* Tabs Content */}
                <TabContent activeTab={activeTab}>
                  <TabPane tabId="day">
                    <h5>Daily Activity Details</h5>
                    <Table responsive bordered>
                      <thead className="table-primary text-dark">
                        <tr>
                          <td>#</td>
                          <td>Email Date</td>
                          <td>Email Type</td>
                          <td>Sign-ups</td>
                          <td>Completed Activities</td>
                          <td>Completed Distance</td>
                        </tr>
                      </thead>
                      <tbody>
                        {data
                          ?.filter(item => item?.title.includes("Daily"))
                          ?.map((item, index) => (
                            <tr key={index}>
                              <td>{index + 1}</td>
                              <td>
                                {moment?.(item?.createdAt)?.format(
                                  "DD-MM-YYYY"
                                )}
                              </td>
                              <td>Daily</td>
                              <td>
                                {JSON.parse(item?.body)?.signups ??
                                  JSON.parse(item?.body)?.totalSignups}
                              </td>
                              <td>
                                {JSON.parse(item?.body)?.activities ??
                                  JSON.parse(item?.body)?.totalActivities}
                              </td>
                              <td>
                                {JSON.parse(item?.body)?.distance ??
                                  JSON.parse(item?.body)?.totalDistance}
                              </td>
                            </tr>
                          ))}
                      </tbody>
                    </Table>
                  </TabPane>

                  <TabPane tabId="week">
                    <h5>Weekly Activity Details</h5>
                    <Table responsive bordered>
                      <thead className="table-primary text-dark">
                        <tr>
                          <td>#</td>
                          <td>Email Date</td>
                          <td>Email Type</td>
                          <td>Sign-ups</td>
                          <td>Completed Activities</td>
                          <td>Completed Distance</td>
                        </tr>
                      </thead>
                      <tbody>
                        {data
                          ?.filter(item => item?.title.includes("Sunday"))
                          ?.map((item, index) => (
                            <tr key={index}>
                              <td>{index + 1}</td>
                              <td>
                                {moment?.(item?.createdAt)?.format(
                                  "DD-MM-YYYY"
                                )}
                              </td>
                              <td>Weekly</td>
                              <td>{JSON.parse(item?.body)?.signups}</td>
                              <td>{JSON.parse(item?.body)?.activities}</td>
                              <td>{JSON.parse(item?.body)?.distance}</td>
                            </tr>
                          ))}
                      </tbody>
                    </Table>
                  </TabPane>

                  <TabPane tabId="month">
                    <h5>Monthly Activity Details</h5>
                    <Table responsive bordered>
                      <thead className="table-primary text-dark">
                        <tr>
                          <td>#</td>
                          <td>Email Date</td>
                          <td>Email Type</td>
                          <td>Sign-ups</td>
                          <td>Completed Activities</td>
                          <td>Completed Distance</td>
                        </tr>
                      </thead>
                      <tbody>
                        {data
                          ?.filter(item => item?.title.includes("Monthly"))
                          ?.map((item, index) => (
                            <tr key={index}>
                              <td>{index + 1}</td>
                              <td>
                                {moment?.(item?.createdAt)?.format(
                                  "DD-MM-YYYY"
                                )}
                              </td>
                              <td>Monthly</td>
                              <td>{JSON.parse(item?.body)?.signups}</td>
                              <td>{JSON.parse(item?.body)?.activities}</td>
                              <td>{JSON.parse(item?.body)?.distance}</td>
                            </tr>
                          ))}
                      </tbody>
                    </Table>
                  </TabPane>

                  <TabPane tabId="activeInactive">
                    <div className="d-flex justify-flex-start align-items-start gap-2 mb-3">
                      <div className="col-md-2 budget_status pt-2 px-1 rounded invoice-status text-center">
                        <h5>Total Users </h5>
                        <h3>{inactiveUsers?.totalUsersCount || 0}</h3>
                      </div>
                      <div className="col-md-2 budget_status pt-2 px-1 rounded invoice-status text-center">
                        <h5>Active Users </h5>
                        <h3>
                          {inactiveUsers?.totalUsersCount -
                            inactiveUsers?.inactiveCount || 0}
                        </h3>
                      </div>
                      <div className="col-md-2 budget_status pt-2 px-1 rounded invoice-status text-center">
                        <h5>Inactive Users </h5>
                        <h3>{inactiveUsers?.inactiveCount || 0}</h3>
                      </div>
                    </div>
                    <h4 className="my-3 fw-bold text-dark">
                      InActive Users List
                    </h4>
                    <Table responsive bordered>
                      <thead className="table-primary text-dark">
                        <tr>
                          <td>#</td>
                          <td>User Name</td>
                          <td>Email</td>
                          <td>Club Name</td>
                          <td>Birth Date</td>
                          <td>Gender</td>
                        </tr>
                      </thead>
                      <tbody>
                        {inactiveUsers?.data?.map((item, index) => (
                          <tr key={index}>
                            <td>{index + 1}</td>
                            <td>{item?.name}</td>
                            <td>{item?.email}</td>
                            <td>{item?.club?.clubName}</td>
                            <td>
                              {moment(item?.birthdate).format("DD-MM-YYYY")}
                            </td>
                            <td>{item?.gender}</td>
                          </tr>
                        ))}
                      </tbody>
                    </Table>
                  </TabPane>
                </TabContent>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  )
}

export default ActivityOverview
